"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ferentino": {
    "a377b273": [{
      "hkey": "6d8e8a11",
      "slug": "cartiera-stazione",
      "name": "Cartiera-Stazione",
      "primary": true,
      "skipSearch": false
    }],
    "cartiera-quarto": [{
      "hkey": "6d8e8a11",
      "slug": "cartiera-stazione",
      "name": "Cartiera-Stazione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "91b1a937": [{
      "hkey": "fc5df4fe",
      "slug": "ferentino",
      "name": "Ferentino",
      "primary": true,
      "skipSearch": false
    }],
    "cercete": [{
      "hkey": "fc5df4fe",
      "slug": "ferentino",
      "name": "Ferentino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "65c6979b": [{
      "hkey": "fc5df4fe",
      "slug": "ferentino",
      "name": "Ferentino",
      "primary": true,
      "skipSearch": false
    }],
    "pareti": [{
      "hkey": "fc5df4fe",
      "slug": "ferentino",
      "name": "Ferentino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c71cea00": [{
      "hkey": "fc5df4fe",
      "slug": "ferentino",
      "name": "Ferentino",
      "primary": true,
      "skipSearch": false
    }],
    "san-rocco": [{
      "hkey": "fc5df4fe",
      "slug": "ferentino",
      "name": "Ferentino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8bce393b": [{
      "hkey": "fc5df4fe",
      "slug": "ferentino",
      "name": "Ferentino",
      "primary": true,
      "skipSearch": false
    }],
    "sant-antonio": [{
      "hkey": "fc5df4fe",
      "slug": "ferentino",
      "name": "Ferentino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "40619f0a": [{
      "hkey": "6d8e8a11",
      "slug": "cartiera-stazione",
      "name": "Cartiera-Stazione",
      "primary": true,
      "skipSearch": false
    }],
    "stazione": [{
      "hkey": "6d8e8a11",
      "slug": "cartiera-stazione",
      "name": "Cartiera-Stazione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferentino"
    }],
    "1dac404c": [{
      "hkey": "4f39a9c8",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "terme-pompeo": [{
      "hkey": "4f39a9c8",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ferentino"
    }],
    "08726a00": [{
      "hkey": "fc5df4fe",
      "slug": "ferentino",
      "name": "Ferentino",
      "primary": true,
      "skipSearch": false
    }],
    "torre-noverana": [{
      "hkey": "fc5df4fe",
      "slug": "ferentino",
      "name": "Ferentino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;